import { render, staticRenderFns } from "./PlatformConnections.vue?vue&type=template&id=6b56c105&"
import script from "./PlatformConnections.vue?vue&type=script&lang=js&"
export * from "./PlatformConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports